// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrv-toast-container {
  z-index: 1060 !important;
  transform: translate(-0.75rem, 5rem);
}

.qrv-toast {
  min-width: 28rem;
  max-width: 32rem;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.qrv-toast-close {
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/pages/QuestionnaireResponse/QuestionnaireResponseViewer.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".qrv-toast-container {\r\n  z-index: 1060 !important;\r\n  transform: translate(-0.75rem, 5rem);\r\n}\r\n\r\n.qrv-toast {\r\n  min-width: 28rem;\r\n  max-width: 32rem;\r\n  background-color: transparent !important;\r\n  border: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.qrv-toast-close {\r\n  z-index: 2;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
